// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"FAQ_FAQ__1MQVq","FAQ__List":"FAQ_FAQ__List__Ffhps"};